/* eslint-disable no-undef */
import Vue from 'vue';
import mockWidgetData from '../mock/widget_mock.js';
import apiurl from '../apiurl';
export default {
    namespaced: true,
    state: {
    },
    getters: {
        getWidgetByName: (state) => {
            return function(name){

              
                return name;
            }
        }
    },
    mutations: {
    },
    actions: {
        async queryWidgetByName({commit}, {params, handle}){

            try {
                commit('startLoading', null, {
                    root: true
                });
            
                if(params.name == "n4Index")
                {                 
                    //commit('保存数据?', rsp.data); 
                    handle(mockWidgetData.new4Index);
                }
                if(params.name == "province")
                {                 
                    //commit('保存数据?', rsp.data); 
                    handle(mockWidgetData.province);
                   
                }
             
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            } 
        },
        async queryWdigetData({commit }, {params, handle }) {
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post("apiUrl.chart.build", params);
                if (rsp && rsp.data) {
                    //commit('保存数据?', rsp.data); 
                    handle && handle(rsp.data);
                }
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async queryWorldMap({commit }, {data, handle }) {
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(apiurl.widgets.wordMap, data);
                handle && handle(rsp);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
    }
}